/** Headline pill text — server verdict_label only (no client recompute). */
export function verdictHeadline(forecast) {
  return forecast.verdict_label || ''
}

export function showPastDueReminderRow(forecast) {
  if (!forecast.reminder_url) return false
  if (forecast.verdict_state === 'short') return true
  if (forecast.verdict_state === 'covered') return true
  return false
}
